import axios from "axios";
import { del, get, post, put } from "./api_helper";
import * as url from "./url_helper";

const postJwtLogin = async data => {
  try {
    const response = await axios.post(url.POST_JWT_LOGIN, data);
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const checkJwtToken = async (token) => {
  try {
    const response = await axios.post(url.CHECK_JWT_TOKEN, {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getReports = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_REPORTS, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const getOptionalReports = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_OPTIONAL_REPORTS, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const getAnnounce = async (token) => {
  try {
    const response = await axios.get(url.GET_ANNOUNCE, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const editAnnounce = async (token, data) => {
  try {
    const response = await axios.post(url.EDIT_ANNOUNCE, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getContentBoxes = async (token, page) => {
  try {
    const response = await axios.get(url.GET_CONTENT_BOXES + page, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addContentBox = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_CONTENT_BOX, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const editContentBox = async (token, data) => {
  try {
    const response = await axios.post(url.EDIT_CONTENT_BOX, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const deleteContentBox = async (token, data) => {
  try {
    const response = await axios.post(url.DELETE_CONTENT_BOX, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const orderContentBox = async (token, data) => {
  try {
    const response = await axios.post(url.ORDER_CONTENT_BOX, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const changePassword = async (token, data) => {
  try {
    const response = await axios.post(url.EDIT_PASSWORD, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const updateProfilePicture = async (token, data) => {
  try {
    const response = await axios.post(url.EDIT_PROFILE_PICTURE, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getCourses = async (token) => {
  try {
    const response = await axios.get(url.GET_COURSES, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addCourse = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_COURSE, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getCourse = async (token, id) => {
  try {
    const response = await axios.get(url.GET_COURSES + "/" + id, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addCourseContent = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_COURSE_CONTENT, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const deleteCourseContent = async (token, data) => {
  try {
    const response = await axios.post(url.DELETE_COURSE_CONTENT, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const uploadImage = async (token, data) => {
  try {
    const response = await axios.post(url.UPLOAD_IMAGE, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const uploadFile = async (token, data) => {
  try {
    const response = await axios.post(url.UPLOAD_FILE, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const completeCourseContent = async (token, data) => {
  try {
    const response = await axios.post(url.COMPLETE_COURSE_CONTENT, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const editCourseContent = async (token, data) => {
  try {
    const response = await axios.post(url.EDIT_COURSE_CONTENT, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const userCourses = async (token) => {
  try {
    const response = await axios.get(url.USER_COURSES, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const editCourse = async (token, data) => {
  try {
    const response = await axios.post(url.EDIT_COURSE, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const deleteCourse = async (token, data) => {
  try {
    const response = await axios.post(url.DELETE_COURSE, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getColoredDates = async (token) => {
  try {
    const response = await axios.get(url.GET_COLORED_DATES, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addColoredDate = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_COLORED_DATE, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getEventCategories = async (token) => {
  try {
    const response = await axios.get(url.GET_EVENT_CATEGORIES, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addEventCategory = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_EVENT_CATEGORY, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const editEventCategory = async (token, id, data) => {
  try {
    const response = await axios.post(url.EDIT_EVENT_CATEGORY + "/" + id, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const deleteEventCategory = async (token, data) => {
  try {
    const response = await axios.post(url.DELETE_EVENT_CATEGORY, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getUsers = async (token) => {
  try {
    const response = await axios.get(url.GET_USERS, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addUser = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_USER, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const editUser = async (token, data) => {
  try {
    const response = await axios.post(url.EDIT_USER, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const deleteUser = async (token, data) => {
  try {
    const response = await axios.post(url.DELETE_USER, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getAccountManagers = async (token) => {
  try {
    const response = await axios.get(url.GET_ACCOUNT_MANAGERS, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getAllDailyProductReports = async (token, payload) => {
  try {
    const response = await axios.get(url.GET_ALL_DAILY_PRODUCT_REPORTS + "?start_date=" + payload.start_date + "&end_date=" + payload.end_date, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getTeams = async (token) => {
  try {
    const response = await axios.get(url.GET_TEAMS, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addTeam = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_TEAM, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const editTeam = async (token, data) => {
  try {
    const response = await axios.post(url.EDIT_TEAM, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const deleteTeam = async (token, data) => {
  try {
    const response = await axios.post(url.DELETE_TEAM, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getLocations = async (token) => {
  try {
    const response = await axios.get(url.GET_LOCATIONS, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getLocation = async (token, data) => {
  try {
    const response = await axios.get(url.GET_LOCATION + "/" + data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const editLocation = async (token, id, data) => {
  try {
    const response = await axios.post(url.EDIT_LOCATION + "/" + id + "/edit", data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addLocation = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_LOCATION, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const importProsprEmployee = async (token, data) => {
  try {
    const response = await axios.post(url.IMPORT_PROSPR_EMPLOYEE, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const importLaborSpreadsheetEmployee = async (token, data) => {
  try {
    const response = await axios.post(url.IMPORT_LABOR_SPREADSHEET_EMPLOYEE, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const importAmanoReport = async (token, data) => {
  try {
    const response = await axios.post(url.IMPORT_AMANO_REPORT, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const importSpotHeroReport = async (token, data) => {
  try {
    const response = await axios.post(url.IMPORT_SPOTHERO_REPORT, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const importSureParkReport = async (token, data) => {
  try {
    const response = await axios.post(url.IMPORT_SUREPARK_REPORT, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const importResolveReport = async (token, data) => {
  try {
    const response = await axios.post(url.IMPORT_RESOLVE_REPORT, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getThirdPartyPlatforms = async (token) => {
  try {
    const response = await axios.get(url.GET_THIRD_PARTY_PLATFORMS, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getParkingTypes = async (token) => {
  try {
    const response = await axios.get(url.GET_PARKING_TYPES, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getReportsForLocation = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_REPORTS_FOR_LOCATION, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const addLeasePayment = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_LEASE_PAYMENT, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const editLeasePayment = async (token, id, data) => {
  try {
    const response = await axios.post(url.EDIT_LEASE_PAYMENT + "/" + id + "/edit", data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const deleteLeasePayment = async (token, data) => {
  try {
    const response = await axios.post(url.DELETE_LEASE_PAYMENT + "/" + data + "/delete", {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addFee = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_FEE, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const editFee = async (token, id, data) => {
  try {
    const response = await axios.post(url.EDIT_FEE + "/" + id + "/edit", data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const deleteFee = async (token, data) => {
  try {
    const response = await axios.post(url.DELETE_FEE + "/" + data + "/delete", {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addCost = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_COST, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const editCost = async (token, id, data) => {
  try {
    const response = await axios.post(url.EDIT_COST + "/" + id + "/edit", data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const deleteCost = async (token, data) => {
  try {
    const response = await axios.post(url.DELETE_COST + "/" + data + "/delete", {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getLaborReports = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_LABOR_REPORT, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const getCoreParkReports = async (token, data) => {
  try {
    const response = await axios.post(url.GET_COREPARK_REPORT, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const getCoreParkTicketsReports = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_COREPARK_TICKETS_REPORT, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const getSpotHeroReports = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_SPOTHERO_REPORT, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const getResolveReports = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_RESOLVE_REPORT, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const getSureParkReports = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_SUREPARK_REPORT, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const getAmanoReports = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_AMANO_REPORT, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const getLeasePaymentReports = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_LEASEPAYMENT_REPORT, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const getMonthlyParkingReports = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_MONTHLYPARKING_REPORT, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const getFeeReports = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_FEE_REPORT, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const getCostReports = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_COST_REPORT, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const editBulkLocations = async (token, data) => {
  try {
    const response = await axios.post(url.EDIT_BULK_LOCATIONS, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addMonthlyParkingSubscription = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_MONTHLY_PARKING_SUBSCRIPTION, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const updateMonthlyParkingPayment = async (token, id, data) => {
  try {
    const response = await axios.post(url.UPDATE_MONTHLY_PARKING + "/" + id + "/update", data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const updateMonthlyParkingSubscriptionPayment = async (token, id, data) => {
  try {
    const response = await axios.post(url.UPDATE_MONTHLY_PARKING_SUBSCRIPTION + "/" + id + "/update", data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const createMonthlyParkingSubscriptionPendingRenewalOrder = async (token, id, data) => {
  try {
    const response = await axios.post(url.CREATE_MONTHLY_PARKING_SUBSCRIPTION_PENDING_RENEWAL_ORDER + "/" + id + "/pending-renewal-order", data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const deleteMonthlyParkingPayment = async (token, id) => {
  try {
    const response = await axios.post(url.DELETE_MONTHLY_PARKING + "/" + id + "/delete", {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getEvents = async (token) => {
  try {
    const response = await axios.get(url.GET_EVENTS, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addEvent = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_EVENT, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const importEvents = async (token, data) => {
  try {
    const response = await axios.post(url.IMPORT_EVENTS, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const editEvent = async (token, id, data) => {
  try {
    const response = await axios.post(url.EDIT_EVENT + "/" + id + "/edit", data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const deleteEvent = async (token, id) => {
  try {
    const response = await axios.post(url.DELETE_EVENT + "/" + id + "/delete", {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const licencePlateCheck = async (data) => {
  try {
    const response = await axios.post(url.LICENCE_PLATE_CHECK, data);
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getEventsReports = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_EVENTS_REPORT, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }
    throw { status: 0, message: "Network error or no response from server" };
  }
};

const getChanges = async (token, location_id) => {
  try {
    const response = await axios.get(url.GET_CHANGES + "/" + location_id, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const makeChange = async (token, data) => {
  try {
    const response = await axios.post(url.MAKE_CHANGE, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getDeveloperTickets = async (token) => {
  try {
    const response = await axios.get(url.GET_DEVELOPER_TICKETS, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addDeveloperTicket = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_DEVELOPER_TICKET, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getMonthlyParkingExportTemplates = async (token) => {
  try {
    const response = await axios.get(url.GET_MONTHLYPARKING_EXPORT_REPORT_TEMPLATES, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const addMonthlyParkingExportTemplate = async (token, data) => {
  try {
    const response = await axios.post(url.ADD_MONTHLYPARKING_EXPORT_REPORT_TEMPLATE, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const deleteMonthlyParkingExportTemplate = async (token, data) => {
  try {
    const response = await axios.post(url.DELETE_MONTHLYPARKING_EXPORT_REPORT_TEMPLATE, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getSquareTransactions = async (token) => {
  try {
    const response = await axios.get(url.SQUARE_TRANSACTIONS_REPORT, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

const getOnboardingSteps = async (token) => {
  try {
    const response = await axios.get(url.GET_ONBOARDING_STEPS, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const checkOnboardingState = async (token, data) => {
  try {
    const response = await axios.post(url.CHECK_ONBOARDING_STATE, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const uploadDriverLicense = async (token, data) => {
  try {
    const response = await axios.post(url.UPLOAD_DRIVER_LICENSE, data, {
      headers: {
        Authorization: `Bearer ${token}`

      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const updateDriverLicenseInformation = async (token, data) => {
  try {
    const response = await axios.post(url.UPDATE_DRIVER_LICENSE_INFORMATION, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const updateSSNInformation = async (token, data) => {
  try {
    const response = await axios.post(url.UPDATE_SSN_INFORMATION, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const updatePassportInformation = async (token, data) => {
  try {
    const response = await axios.post(url.UPDATE_PASSPORT_INFORMATION, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const updateGreenCardInformation = async (token, data) => {
  try {
    const response = await axios.post(url.UPDATE_GREEN_CARD_INFORMATION, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const updateEADInformation = async (token, data) => {
  try {
    const response = await axios.post(url.UPDATE_EAD_INFORMATION, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const signPdf = async (token, data) => {
  try {
    const response = await axios.post(url.SIGN_PDF, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const finishOnboarding = async (token, data) => {
  try {
    const response = await axios.post(url.FINISH_ONBOARDING, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const uploadSSNFile = async (token, data) => {
  try {
    const response = await axios.post(url.UPLOAD_SSN_FILE, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"

      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const uploadSignedDocument = async (token, data) => {
  try {
    const response = await axios.post(url.UPLOAD_SIGNED_DOCUMENT, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"

      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const uploadITINLetter = async (token, data) => {
  try {
    const response = await axios.post(url.UPLOAD_ITIN_LETTER, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"

      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const uploadBirthCertificate = async (token, data) => {
  try {
    const response = await axios.post(url.UPLOAD_BIRTH_CERTIFICATE, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"

      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const uploadPassportFile = async (token, data) => {
  try {
    const response = await axios.post(url.UPLOAD_PASSPORT_FILE, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"

      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const uploadGreenCard = async (token, data) => {
  try {
    const response = await axios.post(url.UPLOAD_GREEN_CARD, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"

      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const uploadEADCard = async (token, data) => {
  try {
    const response = await axios.post(url.UPLOAD_EAD_CARD, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"

      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const updateUserOnboardingConfig = async (token, data) => {
  try {
    const response = await axios.post(url.UPDATE_USER_ONBOARDING_CONFIG, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const prepareFilledEmployeeWithholdingAllowanceCertificate = async (token, data) => {
  try {
    const response = await axios.post(url.PREPARE_FILLED_EMPLOYEE_WITHHOLDING_ALLOWANCE_CERTIFICATE, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside 2xx
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Login failed"
      };
    } else {
      // Network error or no response
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

// Login audit trail. Admin only — the API answers 401 for every other role.
const getLoginLogs = async (token, params = {}) => {
  try {
    const response = await axios.get(url.GET_LOGIN_LOGS, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Could not load login activity"
      };
    } else {
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

const getLoginLogsSummary = async (token, days = 30) => {
  try {
    const response = await axios.get(url.GET_LOGIN_LOGS_SUMMARY, {
      params: { days },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data?.message || "Could not load the login summary"
      };
    } else {
      throw {
        status: 0,
        message: "Network error or no response from server"
      };
    }
  }
};

export {
  getLoginLogs,
  getLoginLogsSummary,
  postJwtLogin,
  checkJwtToken,
  getReports,
  getAnnounce,
  editAnnounce,
  changePassword,
  updateProfilePicture,
  getCourses,
  addCourse,
  getCourse,
  deleteCourse,
  addCourseContent,
  uploadImage,
  uploadFile,
  completeCourseContent,
  editCourseContent,
  deleteCourseContent,
  userCourses,
  editCourse,
  getColoredDates,
  addColoredDate,
  getEventCategories,
  addEventCategory,
  editEventCategory,
  deleteEventCategory,
  getAccountManagers,
  getUsers,
  addUser,
  editUser,
  deleteUser,
  getTeams,
  editTeam,
  addTeam,
  deleteTeam,
  getContentBoxes,
  addContentBox,
  editContentBox,
  deleteContentBox,
  orderContentBox,
  postJwtRegister,
  postJwtForgetPwd,
  getLocations,
  getLocation,
  editLocation,
  addLocation,
  importProsprEmployee,
  getThirdPartyPlatforms,
  getParkingTypes,
  importLaborSpreadsheetEmployee,
  importAmanoReport,
  importSpotHeroReport,
  importSureParkReport,
  importResolveReport,
  getReportsForLocation,
  addLeasePayment,
  editLeasePayment,
  deleteLeasePayment,
  addFee,
  editFee,
  deleteFee,
  addCost,
  editCost,
  deleteCost,
  getLaborReports,
  getCoreParkReports,
  getSpotHeroReports,
  getResolveReports,
  getSureParkReports,
  getAmanoReports,
  getLeasePaymentReports,
  getMonthlyParkingReports,
  getFeeReports,
  getCostReports,
  editBulkLocations,
  addMonthlyParkingSubscription,
  deleteMonthlyParkingPayment,
  getEvents,
  addEvent,
  editEvent,
  deleteEvent,
  importEvents,
  getEventsReports,
  getCoreParkTicketsReports,
  updateMonthlyParkingPayment,
  licencePlateCheck,
  getChanges,
  makeChange,
  getDeveloperTickets,
  addDeveloperTicket,
  updateMonthlyParkingSubscriptionPayment,
  createMonthlyParkingSubscriptionPendingRenewalOrder,
  getMonthlyParkingExportTemplates,
  addMonthlyParkingExportTemplate,
  deleteMonthlyParkingExportTemplate,
  getSquareTransactions,
  getOnboardingSteps,
  checkOnboardingState,
  uploadDriverLicense,
  updateDriverLicenseInformation,
  signPdf,
  finishOnboarding,
  uploadSSNFile,
  uploadITINLetter,
  uploadBirthCertificate,
  uploadPassportFile,
  uploadGreenCard,
  uploadEADCard,
  updateUserOnboardingConfig,
  prepareFilledEmployeeWithholdingAllowanceCertificate,
  updateSSNInformation,
  updatePassportInformation,
  updateGreenCardInformation,
  updateEADInformation,
  uploadSignedDocument,
  getOptionalReports,
  getAllDailyProductReports
};
